import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import Snackbar from "@material-ui/core/Snackbar";
import type { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { deletePost } from "../../../models/post";
import DeleteDialog from "./Dialog";

const useStyles = makeStyles((theme: Theme) => ({
  redButton: {
    color: "white",
    backgroundColor: red[600],
    "&:hover": {
      backgroundColor: red[900],
    },
  },
}));

export default function Delete({ postID }: { postID: string }) {
  const classes = useStyles();
  const [error, setError] = useState<string>();

  const history = useHistory();
  const handleDelete = () => {
    deletePost(postID).then(
      () => {
        history.replace("/posts");
      },
      (e) => {
        setOpen(false);
        switch (e?.response?.status) {
          default:
            setError("エラーが発生し、削除に失敗しました。");
            return;
        }
      }
    );
  };

  const [open, setOpen] = useState<boolean>(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setError("");
  };

  return (
    <>
      <Button
        className={classes.redButton}
        variant="contained"
        onClick={handleClick}
      >
        削除する
      </Button>
      <DeleteDialog open={open} onClose={handleClose} onDelete={handleDelete} />
      <Snackbar open={!!error} onClose={handleSnackbarClose}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </>
  );
}
